import { useSidebarCollapsed } from '@/viewmodel/shared/sidebar/hooks/useSidebarCollapsed';
import type { NavItem, SideBarViewState } from '@/viewmodel/shared/sidebar/types';
import { useState } from 'react';

export function useSideBarViewModel(
  items: readonly NavItem[],
  activeKey: string | undefined,
): SideBarViewState {
  const { collapsed, toggle } = useSidebarCollapsed();
  const activeGroup = items.find((item) => item.key === activeKey)?.group;
  const [openGroups, setOpenGroups] = useState<Record<string, boolean>>({});

  const toggleGroup = (groupName: string): void => {
    setOpenGroups((current) => ({
      ...current,
      [groupName]: !(current[groupName] ?? groupName === activeGroup),
    }));
  };

  return { collapsed, toggleCollapsed: toggle, activeGroup, openGroups, toggleGroup };
}
